import { memo } from "react"

const IconProfile = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_9961_604)">
        <path
          d="M12 0C5.37188 0 0 5.37188 0 12C0 18.6281 5.37188 24 12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0ZM12 6C13.8642 6 15.375 7.51125 15.375 9.375C15.375 11.2387 13.8656 12.75 12 12.75C10.1363 12.75 8.625 11.2387 8.625 9.375C8.625 7.51125 10.1344 6 12 6ZM12 21C9.51891 21 7.27031 19.9908 5.63906 18.3614C6.39844 16.4016 8.27344 15 10.5 15H13.5C15.7284 15 17.6034 16.4006 18.3609 18.3614C16.7297 19.9922 14.4797 21 12 21Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_9961_604">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default memo(IconProfile)
